import React, { useState } from "react";
import { FaLocationDot } from "react-icons/fa6";
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

// import emailjs from "emailjs-com";
import emailjs from "@emailjs/browser";

const ContactForm = ({ carName }) => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    number: "",
    message: "",
    licensePlate: "",
    appointment: "",
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [emailStatus, setEmailStatus] = useState(null);

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!formData.fullName) newErrors.fullName = "Naam is vereist";
    if (!formData.email || !validateEmail(formData.email))
      newErrors.email = "Ongeldig e-mailadres";
    if (!formData.number) newErrors.number = "Nummer is vereist";
    if (!formData.message) newErrors.message = "Bericht is vereist";
    if (!formData.licensePlate)
      newErrors.licensePlate = "Kentekenplaat is vereist";
    if (!formData.appointment) newErrors.appointment = "afspraak is vereist";

    setErrors(newErrors);

    if (Object.keys(newErrors).length !== 0) return;

    setIsLoading(true);

    // Prepare the parameters to match your EmailJS template placeholders.
    const templateParams = {
      name: formData.fullName, // Make sure this matches your EmailJS template placeholder
      email: formData.email,
      number: formData.number,
      message: formData.message,
      licensePlate: formData.licensePlate,
      appointment: formData.appointment,
      carInfo: carName || "",
    };

    try {
      await emailjs.send(
        "service_cnlhcq5", // Replace with your EmailJS service ID
        "template_lw70f9c", // Replace with your EmailJS template ID
        templateParams,
        "2rwwu502Od15TPbDz", // Replace with your EmailJS public key
      );

      /* 
        await emailjs.send(
          'YOUR_SERVICE_ID',
          'YOUR_TEMPLATE_ID',
          {},
          {
            publicKey: 'YOUR_PUBLIC_KEY',
          },
        );
      */
      setEmailStatus("Email sent successfully!");

      setFormData({
        fullName: "",
        email: "",
        number: "",
        message: "",
        licensePlate: "",
        appointment: "",
      });
    } catch (error) {
      console.error("Error:", error);
      setEmailStatus("Failed to send email. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  // try {
  //   await emailjs.send(
  //     'service_cnlhcq5', // Replace with your EmailJS service ID
  //     'template_esshcqn', // Replace with your EmailJS template ID
  //     templateParams,
  //     '2rwwu502Od15TPbDz' // Replace with your EmailJS public key
  //   );
  //   setEmailStatus('Email sent successfully!');
  // } catch (error) {
  //   console.error('Error:', error);
  //   setEmailStatus('Failed to send email. Please try again later.');
  // }

  return (
    <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center p-4">
      <h1 className="text-3xl font-bold text-red-500 mb-6">Contact Us</h1>

      <div className="relative w-full max-w-4xl">
        {/* <div className="absolute inset-0 bg-gradient-to-br from-red-600 to-black rounded-xl p-1">
          <div
            className="absolute inset-0 bg-cover bg-center rounded-xl"
            style={{ backgroundImage: "url(/your-image.jpg)" }}
          ></div>
        </div> */}

        <div className="relative bg-gradient-to-br from-red-800 to-black p-6 rounded-xl shadow-lg max-w-2xl mx-auto">
          <form className="space-y-4">
            <div className="grid grid-cols-1 gap-4">
              {/* <div>
                <label className="block text-sm">Aanhef*</label>
                <select className="w-full p-2 bg-white border border-red-500 rounded">
                  <option>Option 1</option>
                  <option>Option 2</option>
                </select>
              </div> */}
              <div>
                <label className="block text-sm">Naam*</label>
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleInputChange}
                  className="w-full p-2 bg-white text-black font-medium border border-red-500 rounded"
                />
                {errors.fullName && (
                  <p className="text-[#F5A623] text-sm mt-1">
                    {errors.fullName}
                  </p>
                )}
              </div>
            </div>
            <div>
              <label className="block text-sm">Emailadres*</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                className="w-full p-2 bg-white text-black font-medium border border-red-500 rounded"
              />
              {errors.email && (
                <p className="text-[#F5A623] text-sm mt-1">{errors.email}</p>
              )}
            </div>

            <div>
              <label className="block text-sm">Telefoonnummer*</label>
              <input
                type="tel"
                name="number"
                value={formData.number}
                onChange={handleInputChange}
                className="w-full p-2 bg-white text-black font-medium border border-red-500 rounded"
              />
              {errors.number && (
                <p className="text-[#F5A623] text-sm mt-1">{errors.number}</p>
              )}
            </div>
            <div>
              <label className="block text-sm">Bericht*</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                className="w-full p-2 bg-white text-black font-medium border border-red-500 rounded h-32"
              />
              {errors.message && (
                <p className="text-[#F5A623] text-sm mt-1">{errors.message}</p>
              )}
            </div>

            <div>
              <label className="block text-sm">Kenteken*</label>
              <input
                type="text"
                name="licensePlate"
                value={formData.licensePlate}
                onChange={handleInputChange}
                className="w-full p-2 bg-white text-black font-medium border border-red-500 rounded"
              />
              {errors.licensePlate && (
                <p className="text-[#F5A623] text-sm mt-1">
                  {errors.licensePlate}
                </p>
              )}
            </div>

            <div>
              <label className="block text-sm">Afspraak inplannen*</label>
              <div className="flex gap-4">
                <label className="flex items-center">
                  <input
                    type="radio"
                    name="appointment"
                    value="ja"
                    checked={formData.appointment === "ja"}
                    onChange={handleInputChange}
                    className="mr-2"
                  />
                  Ja
                </label>

                <label className="flex items-center">
                  <input
                    type="radio"
                    name="appointment"
                    value="nee"
                    checked={formData.appointment === "nee"}
                    onChange={handleInputChange}
                    className="mr-2"
                  />
                  Nee
                </label>
              </div>
              {errors.appointment && (
                <p className="text-[#F5A623] text-sm mt-1">
                  {errors.appointment}
                </p>
              )}
            </div>
            <div className="text-white text-lg font-semibold">
              <p>{carName}</p>
            </div>
            <button
              type="submit"
              onClick={handleSubmit}
              className="w-full bg-red-600 hover:bg-red-700 text-white p-2 rounded"
            >
              Verzenden
            </button>
          </form>
          {isLoading && <p className="mt-5 font-medium">Sending email...</p>}
          {emailStatus && <p className="mt-5 font-medium">{emailStatus}</p>}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-10">
        <div className="bg-black border border-red-500 p-4 rounded-xl text-center hover:shadow-red-500 hover:shadow-lg transition duration-300">
          <p className="font-bold flex items-center justify-center gap-2">
            <FaLocationDot /> Adres:
          </p>
          <p>Industrieweg 1-37 2712 LA Zoetermeer</p>
        </div>
        <div className="bg-black border border-red-500 p-4 rounded-xl text-center hover:shadow-red-500 hover:shadow-lg transition duration-300">
          <p className="font-bold flex items-center justify-center gap-2">
            <FaPhoneAlt /> Telefoonnummer:
          </p>
          <p>06 13 10 00 91</p>
        </div>
        <div className="bg-black border border-red-500 p-4 rounded-xl text-center hover:shadow-red-500 hover:shadow-lg transition duration-300">
          <p className="font-bold flex items-center justify-center gap-2">
            <MdEmail /> E-mailadres:
          </p>
          <p>info@x-tremetunings.nl</p>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
